import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import { getApi } from "@api/apiPath";
import { axiosClient } from "@api/clients.ts";
import type { IAdminProfileStatisticsEndpoint } from "@api/system/adminProfileStatistics/types";
import type { IApiResponse } from "@/api";

const { key, getPath } = getApi("system.adminProfileStatistics.get");

const getAdminProfileStatistics: Fetcher<
  IApiResponse<IAdminProfileStatisticsEndpoint>
> = (params) => {
  return axiosClient.get(getPath(), { params });
};

export const useGetAdminProfileStatistics = createQuery({
  queryKey: [key],
  fetcher: getAdminProfileStatistics,
});
